import { h } from 'preact';
import ProductCardShopTheLook from 'utils/product-card-shop-the-look';
import { useEffect, useState } from 'preact/hooks';
import * as queries from 'utils/storefront/queries';
import Storefront from 'utils/storefront';
import clsx from 'clsx';
import { edgesToNodes } from 'utils/storefront/format-resource';
import filterShopTheLook from 'utils/ab-test';

const ProductShopTheLookVc = (props) => {
  const title = props.language === 'fr' 
  ? (window.STOREFRONT === "LC" ? "Plus d'ensembles parfaits" : "Et s'agence parfaitement à") 
  : (window.STOREFRONT === "LC" ? "More Perfect Matches" : "Also Pairs Great With");
  const { currentProduct } = props;
  const styleNumber = Number(currentProduct.masterSKU.value.split('-')[0]);
  const abTestFilter = filterShopTheLook(styleNumber);
  const filteredItems = props.pairsWithProducts.products
  .filter(item => abTestFilter.includes(item.styleNumber))
  .filter(item => !props.shopTheLook.products
    .some(product => product.id === item.id));
  const [products, setProducts] = useState(    
    // props.pairsWithProducts?.products.filter((product) => product.id) || [],
    filteredItems?.filter((product) => product.id) || [],
  );

  useEffect(() => {
    const productUpdateHandle = async (e) => {
      if (e.detail.pairsWith) {
      const productIds = JSON.parse(e.detail.pairsWith);
      const storefront = Storefront.getInstance();
      const getProducts = async (ids) => {
        const response = await storefront.request({
          query: queries.getProductsByIds,
          variables: {
            ids,
          },
        });
        if (!response.data) {
          // eslint-disable-next-line no-console
          console.error(
            'product/product-shop-the-look-vc.js: Storefront API request failed',
            response,
          );
          return [];
        }
        return edgesToNodes(
          response.data.nodes
          .filter((i) => i)
          .filter(i => abTestFilter
            .includes(Number(i.masterSKU.value.split('-')[0])))
          .filter(i => !props.shopTheLook.products
          .some(product => product.id === i.id)),
          'product',
        );
      };
      getProducts(productIds).then((data) => setProducts(data));
    }else{
      setProducts([]);
    } 
  }
    document.addEventListener('productUpdated', productUpdateHandle);
    return () => {
      document.removeEventListener('productUpdated', productUpdateHandle);
    };
  }, []);
  

  return (
    products.length > 0 && (
      <div className={`my-16 mt-32 lc:lg:my-20 lc:lg:mt-36 
      ab-test-kan58 shop-the-look-vc`}>
        <div className="lc:body-1 ml:display-4 lc:mb-8 
        ml:mb-16 ml:text-center">
          {title}
        </div>
        <div
          id="shop-the-look-grid-vc"
          className={clsx(
            '-mx-24 max-w-container md:mx-auto grid lc:gap-8 ml:gap-8',
            {
              'grid-cols-1': products.length === 1 && window.STOREFRONT === 'ML',
              'grid-cols-2': products.length > 1 || window.STOREFRONT === 'LC',
            },
          )}      
        >
          {products.slice(0, 4).map((productItem) => (
            <ProductCardShopTheLook
              key={productItem.id}
              productItem={productItem}
              {...props}
            />
          ))}
        </div>
      </div>
    )
  );
};

export default ProductShopTheLookVc;
